module.exports = __webpack_public_path__ + "img/plus.f00b6562.png";